import PropTypes from 'prop-types';
import React from 'react';
import * as Yup from 'yup';
import Alert from '../../components/shared/Alert';
import EditorButtons from '../../components/shared/EditorButtons';
import EditorContainer from '../../components/shared/EditorContainer';
import EditorForm from '../../components/shared/EditorForm';
import NameField from '../../components/shared/NameField';
import PrepAreaSelect from '../../components/shared/PrepAreaSelect';
import StatusSelect from '../../components/shared/StatusSelect';
import { PATH_KEY_TO_POSITION } from '../../constants';
import useEditor from '../../hooks/use-editor';
import {
  requiredLabel,
  requiredNameWithMaxLength,
  requiredParentId,
  requiredStatus,
  requiredType,
} from '../../utils/validation';
import EditorRow from '../shared/EditorRow';

const LEVEL = PATH_KEY_TO_POSITION['categoryIdx'];

const validation = Yup.object({
  name: requiredNameWithMaxLength,
  status: requiredStatus,
  label: requiredLabel,
  type: requiredType,
  parent_id: requiredParentId,
});

function CategoryEditor(props) {
  const { parent, category, menuIdx, categoryIdx, onCancel, setShowEditor } =
    props;

  let createMode = true;
  if (category) {
    createMode = false;
  }

  const {
    item,
    error,
    loading,
    updateHandler,
    submitHandler,
    deleteHandler,
    onFieldChange,
  } = useEditor({
    init: category,
    parent,
    validation,
    type: 'category',
    path: [
      { key: 'menuIdx', value: menuIdx },
      { key: 'categoryIdx', value: categoryIdx },
    ],
    setShowEditor,
  });

  const onNameChange = onFieldChange('name');
  const onLabelChange = onFieldChange('label');
  const onStatusChange = onFieldChange('status');

  return (
    <EditorContainer level={LEVEL}>
      <EditorForm>
        <NameField
          id={`category-name-${item.id}`}
          type="category"
          value={item.name || ''}
          placeholder="e.g. Breakfast or Burgers"
          onChange={onNameChange}
        />
        <PrepAreaSelect
          id={`category-prep-select-${item.id}`}
          value={item.label}
          onChange={onLabelChange}
        />
        <EditorRow>
          <StatusSelect
            id={`category-status-select-${item.id}`}
            value={item.status}
            onChange={onStatusChange}
          />
        </EditorRow>
        <EditorButtons
          type="category"
          create={createMode}
          loading={loading}
          onCancel={onCancel}
          onSubmit={submitHandler}
          onUpdate={updateHandler}
          onDelete={deleteHandler}
        />
      </EditorForm>
      {error ? <Alert>{error}</Alert> : null}
    </EditorContainer>
  );
}

CategoryEditor.propTypes = {
  parent: PropTypes.object.isRequired,
  categoryIdx: PropTypes.number,
};

export default CategoryEditor;



// WEBPACK FOOTER //
// ./src/components/Dashboard/Panels/MenuEditor/components/CategoryList/category-editor.jsx